import { render, staticRenderFns } from "./template04.vue?vue&type=template&id=53322496&scoped=true&"
import script from "./template04.vue?vue&type=script&lang=js&"
export * from "./template04.vue?vue&type=script&lang=js&"
import style0 from "./template04.vue?vue&type=style&index=0&id=53322496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53322496",
  null
  
)

export default component.exports